<template>
  <Modal v-model="orderProductModal" :title="$t('key1000383')" :width="800" :transfer="false" :mask-closable="true"
    class-name="commonModalStyles" @on-visible-change="orderProductChange">
    <!--筛选区域-->
    <div class="flex align-items-center mb24">
      <dropDownFilter
        ref="dropDownFilter"
        :selectStyle="{width: '110px'}"
        :inputStyle="{width: '220px'}"
        :dropDownInputList="dropDownInputList"
        :defaultSelectValue="defaultSelectValue"
        @changeInput="changeInput"
        @updateInputValue="updateInputValue">
      </dropDownFilter>
      <Button class="ml30 mr10" @click="reset">{{ $t('key1000109') }}</Button>
      <Button type="primary" @click="search">{{ $t('key1000361') }}</Button>
    </div>
    <!--商品信息区域-->
    <div class="goodList_box">
      <Row class="goodList_box_title">
        <Col :span="15">{{ $t('key1000383') }}</Col>
        <Col :span="6">{{ $t('key1001110') }}</Col>
        <Col :span="3">{{ $t('key1000523') }}</Col>
      </Row>
      <div class="goodList_box_content">
        <Row v-for="(item, index) in ymsGoodsList" :key="index" class="goodList_box_content_item">
          <Col :span="24" class="mb15">
            <span class="icon iconfont themeColor">&#xe69e;</span>
            <Tag color="primary" class="font-size-12 ml8 mr8" v-if="item.isSelfOperated === 1">{{ $t('key1004308') }}</Tag>
            <span class="themeColor ml5 font-size-15">{{ item.isSelfOperated === 1 ? userInfo.userName : item.supplierName }}</span>
          </Col>
          <div v-for="(ele, idx) in item.goodList" :key="idx" class="mb20 wid100P flex">
            <Col :span="15" class="flex">
              <div class="img_box" v-viewer="{url: 'data-original', ...viewerOptions}">
                <img
                  :src="setImgPath(ele.primaryImage, null, '70x70', null, true)"
                  :data-original="setImgPath(ele.primaryImage, null, null, null, false)"
                  @error="setErrorImg($event)"
                  alt="">
              </div>
              <div class="ml10">
                <p class="mb2 width_300 ellipsis_1 color-333 font-weight-bold" :title="ele.productName">{{ ele.productName }}</p>
                <p class="mb2">{{ configCharacters(false) + 'SPU：' + ele.ymsSpu }}</p>
                <p class="mb2">{{ configCharacters(false) + 'SKU：' + ele.ymsSku }}</p>
                <p class="greenColor">{{ ele.specifications }}</p>
                <div v-if="ele.isNeedCustomization === 1" class="flex align-items-center mt2">
                  <span class="themeColor">{{ $t('key1004307') + ele.originalYmsSku }}</span>
                  <Tooltip max-width="450" placement="top" transfer :content="$t('key1004306')">
                    <Icon type="md-alert" color="#2D8CF0" class="cursor ml5 themeColor" size="17"/>
                  </Tooltip>
                </div>
              </div>
            </Col>
            <Col :span="6">{{ amountHandel(ele.productGoodsCost) + ' ' + ele.currency }}</Col>
            <Col :span="3">{{ ele.quantity }}</Col>
          </div>
        </Row>
      </div>
    </div>
    <template #footer>
      <Button type="primary" @click="orderProductModal = false">{{ $t('key1000316') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {getSupplierData, amountHandel, setConfigCharacters} from "@/utils/common";
import dropDownFilter from "@/components/common/dropDownFilter.vue";

export default {
  name: 'orderProductModal',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      orderProductModal: false,
      pageParam: {
        name: '',
        ymsSpu: '',
        ymsSku: '',
        /*  pageNum: 1,
          pageSize: 15*/
      },
      defaultSelectValue: 1,
      dropDownInputList: [
        {title: `${setConfigCharacters(false)}SPU`, parameterKey: 'ymsSpu', value: 1, placeholder: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000324')}${setConfigCharacters(false)}SPU`},
        {title: `${setConfigCharacters(false)}SKU`, parameterKey: 'ymsSku', value: 2, placeholder: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000324')}${setConfigCharacters(false)}SKU`},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000380'), parameterKey: 'name', value: 3, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000381')},
      ],
      ymsGoodsList: [],
      ymsPackageId: null,
    }
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    }
  },
  methods: {
    amountHandel,
    // 初始化数据
    initOrderProductData(obj) {
      this.ymsPackageId = obj.ymsPackageId;
      this.getList();
      this.orderProductModal = true;
    },
    // 获取商品数据
    getList() {
      let query = {
        ymsPackageId: this.ymsPackageId,
        name: this.pageParam.name,
        ymsSpu: this.pageParam.ymsSpu,
        ymsSku: this.pageParam.ymsSku,
      }
      this.ymsGoodsList = [];
      this.axios.post(api.post_ymsPackageInfo_queryPackageGoodsList, query,
        {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003332')}).then(async (response) => {
        if (response.data.code === 0) {
          let data = response.data.datas || [];
          let ymsProductGoodsIds = [...new Set(data.map(i => i.ymsProductGoodsId).filter(Boolean))];
          let supplierMerchantIds = [...new Set(data.map(i => i.supplierMerchantId).filter(Boolean))];
          if (ymsProductGoodsIds.length > 0) {
            let ymsProductGoodData = await this.getProductInfoByIds(ymsProductGoodsIds, data, false, false);
            let supplierData = await getSupplierData(supplierMerchantIds);
            ymsProductGoodData.map((item) => {
              item.productName = item._productInfo?._spuInfo?.name || '';
              item.ymsSpu = item._productInfo?._spuInfo?.ymsSpu || '';
              item.primaryImage = item._productInfo?.primaryImage || item._productInfo?._spuInfo?.primaryImage;
              let productGoodsSpecificationList = item._productInfo?.productGoodsSpecificationList || [];
              let valueList = productGoodsSpecificationList.map((p) => {
                return p.value;
              });
              item.specifications = valueList.join(' • ');
              supplierData.map((ele) => {
                if (item.supplierMerchantId === ele.ymsMerchantId) {
                  item['supplierName'] = ele.name;
                }
              });
              item.isSelfOperated = item._productInfo?._spuInfo?.isSelfOperated || 0;
            });
            let newData = this.handerGrouping(ymsProductGoodData, function (item) {
              return [item.supplierMerchantId];
            }, ['supplierMerchantId', 'supplierName', 'isSelfOperated'], 'goodList');
            this.ymsGoodsList = newData;
          }
        }
      });
    },
    // 重置
    reset() {
      this.pageParam = {
        name: '',
        ymsSpu: '',
        ymsSku: ''
      };
      this.changeInput(1);
    },
    // 查询
    search() {
      this.getList();
    },
    // 获取下拉选项筛选条件的值
    updateInputValue(data) {
      this.pageParam[data.key] = data.value;
    },
    // 改变默认下拉选项的值
    changeInput(value) {
      this.defaultSelectValue = value;
      this.$refs.dropDownFilter.inputValue = '';
      this.dropDownInputList.map((item) => {
        if (Object.keys(this.pageParam).includes(item.parameterKey)) {
          this.pageParam[item.parameterKey] = '';
        }
      });
    },
    // 监听弹窗
    orderProductChange(value) {
      if (!value) {
        this.reset();
      }
    }
  },
  components: {
    dropDownFilter
  }
};
</script>

<style lang="less" scoped>
.commonModalStyles {
  .goodList_box {
    .goodList_box_title {
      padding: 10px 30px;
      background-color: #F7F7F7;
      color: #333;
      font-size: 15px;
      font-weight: bold;
      border-radius: 2px;
    }

    .goodList_box_content {
      background-color: #fff;

      .goodList_box_content_item {
        padding: 10px 30px;
        border-bottom: 1px solid #E9E9E9;
        margin-bottom: 15px;

        .img_box {
          width: 70px;
          height: 70px;
          position: relative;
          cursor: pointer;

          img {
            display: inline-block;
            left: 50%;
            max-height: 100%;
            max-width: 100%;
            position: absolute;
            top: 50%;
            transform: translateY(-50%) translateX(-50%);
          }
        }

        &:last-child {
          border-bottom: none;
        }
      }
    }
  }
}
</style>
